import React, { useEffect } from "react";
import Development from "../components/Service/Development";
import PromoCMSOLTEC from "../components/Service/PromoCMSOLTEC";
import BrandsCarousel from "../components/Home/BrandsCarousel";
import Services from "../components/Service/Services"
import ServiceSoftware from "../components/Service/ServiceSoftware";
import PrintUX from "../components/Service/PrintUX";

const HomePage = () => {
  useEffect(() => {
    document.title = "CMSOLTEC | Servicios";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <PrintUX />
      <PromoCMSOLTEC />
      <Services />
      <ServiceSoftware />
      <BrandsCarousel />
      <Development />
    </main>
  );
};

export default HomePage;
